import { Component, Show } from "solid-js";

const SummaryPanel: Component<{
  text: string;
  class?: string;
  loading?: boolean;
  error?: string;
  onRegenerate?: () => void;
}> = (props) => (
  <div class="card">
    <div class="flex items-center justify-between mb-2">
      <h2 class="text-xl font-semibold">Summary Notes</h2>
      <Show when={props.onRegenerate}>
        <button
          type="button"
          onClick={() => props.onRegenerate?.()}
          disabled={props.loading}
          class="p-1.5 text-gray-500 hover:text-blue-600 hover:bg-blue-50 rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          title="Regenerate insights"
        >
          <Show
            when={!props.loading}
            fallback={
              <svg class="w-5 h-5 animate-spin" fill="none" viewBox="0 0 24 24">
                <circle
                  class="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  stroke-width="4"
                />
                <path
                  class="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                />
              </svg>
            }
          >
            <svg
              class="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
              />
            </svg>
          </Show>
        </button>
      </Show>
    </div>
    <Show when={props.error}>
      <div class="mb-3 p-3 bg-red-50 border border-red-200 rounded-md text-sm text-red-700">
        <span class="font-medium">Failed to generate insights:</span>{" "}
        {props.error}
      </div>
    </Show>
    <Show when={props.loading && !props.text}>
      <p class="text-gray-400 italic">Generating summary...</p>
    </Show>
    <Show when={!props.loading || props.text}>
      <p class="whitespace-pre-wrap">{props.text || "No summary available."}</p>
    </Show>
  </div>
);

export default SummaryPanel;
